<template>
  <b-card>
    <b-static-table
      :items="mappedProviders"
      :fields="providersTableFields"
      :loading="loading"
      show-search
      @item-click="onProviderClicked"
      @item-middle-click="onProviderMiddleClicked"
    />
  </b-card>
</template>

<script>
import { BCard } from "bootstrap-vue";
import BStaticTable from "@foravila-core/components/b-static-table/BStaticTable.vue";
import { notifyError } from "@/utils/methods";

export default {
  components: {
    BCard,
    BStaticTable,
  },
  data() {
    return {
      providersTableFields: [
        { key: "firstName", label: this.$t("Nom"), sortable: true },
        { key: "lastName", label: this.$t("Llinatges"), sortable: true },
        { key: "phone", label: this.$t("Telèfon"), sortable: true },
        { key: "email", label: this.$t("Email"), sortable: true },
      ],
    };
  },
  computed: {
    loading() {
      return this.$store.getters["providers/loading"];
    },
    providers() {
      return this.$store.getters["providers/providers"];
    },
    mappedProviders() {
      if (!this.providers?.length) return [];
      return this.providers.map((item) => ({
        uuid: item.uuid || this.$t("No definit"),
        firstName: item.firstName || this.$t("No definit"),
        lastName: item.lastName || this.$t("No definit"),
        phone: item.phone || this.$t("No definit"),
        email: item.email || this.$t("No definit"),
      }));
    },
  },
  created() {
    if (!this.providers?.length && !this.loading) this.fetchProviders();
  },
  methods: {
    fetchProviders() {
      this.$store
        .dispatch("providers/fetchProviders", {
          pagination: false,
          sort: "asc",
        })
        .catch(() =>
          notifyError(
            this.$t("errors.fetchProviders.title"),
            this.$t("errors.fetchProviders.description")
          )
        );
    },
    onProviderClicked(providerUuid) {
      const provider = this.providers.find((p) => p.uuid === providerUuid);
      if (provider) {
        const name =
          provider.fullName ||
          [provider.firstName, provider.lastName].filter(Boolean).join(" ") ||
          null;
        this.$store.dispatch("app/setPageTitle", name);
      }
      this.$router.push({
        name: "foravila-provider-view",
        params: { providerUuid },
      });
    },
    onProviderMiddleClicked(providerUuid) {
      const routeData = this.$router.resolve({
        name: "foravila-provider-view",
        params: { providerUuid },
      });
      window.open(routeData.href, "_blank");
    },
  },
};
</script>
